import React, { useEffect, useState } from "react";
import { Col, Row, Tab } from "react-bootstrap";
import "./Style.css";
import useWindowSize from "../../utils/useWindowSize";
import { Button, Select, Modal, Table, message } from "antd";
import DopdownMenuWithMonth from "./DopdownMenuWithMonth";
import { connect } from "react-redux";
import Logout from "../../containers/Pages/Login/Logout";

import useSession from "../CustomLogout/useSession";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Input } from "antd";
import { regen_payout_V } from "../../redux/Url";
import PayoutManagmentListing from "./PayoutManagementListing/PayoutManagmentListing";

import { payoutListChanalwiseDataSuccess } from "../../redux/PayoutListByFY/Action";
import PayoutManagmentListingChanalwise from "./PayoutManagementListing/payoutManagmentListingChanalwise";



export const ChanalWiseReportCppChecker = (props) => {

  const { width } = useWindowSize();
  const dispatch = useDispatch();
  const [regenerateData, setRegeneratedData] = useState([]);
  const [missingMonthsGen, setMissingMonthsGen] = useState([]);
  const [missingMonthsReGen, setMissingMonthsReGen] = useState([]);
  const [payoutListData, setPayoutListData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [generatingReport, setGeneratingReport] = useState(false);
  const [isFetchingMissingMonths, setIsFetchingMissingMonths] = useState(false);
  const [isLoadingReGenerate, setIsLoadingReGenerate] = useState(false);
  const [isLoadingGenerate, setIsLoadingGenerate] = useState(false);
  const [downloading, setDownloading] = useState(false);


  const handleSessionExpired = useSession();
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    // Assuming FY starts in April
    return today.getMonth() >= 3
      ? { value: String(year), label: `${year}-${String(year + 1).slice(-2)}` }
      : { value: String(year - 1), label: `${year - 1}-${String(year).slice(-2)}` };
  };

  // Financial year state
  const [financialYear, setFinancialYear] = useState(getCurrentFinancialYear().value);

  const monthMap = {
    "JAN": "January",
    "FEB": "February",
    "MAR": "March",
    "APR": "April",
    "MAY": "May",
    "JUN": "June",
    "JUL": "July",
    "AUG": "August",
    "SEP": "September",
    "OCT": "October",
    "NOV": "November",
    "DEC": "December",
  };



  const generateFinancialYearOptions = (startYear = 2022) => {
    const today = new Date();
    const year = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
    const options = [];
    for (let y = year; y >= startYear; y--) {
      options.push({
        value: String(y),
        label: `${y}-${String(y + 1).slice(-2)}`,
      });
    }
    return options;
  };

  // Pagination state
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  // Fetch payout list with pagination
  const fetchPayoutList = async (page = 1, pageSize = 10, fy = financialYear) => {
    setDownloading(true);
    try {
      const payoutList = props.payoutListByFY({
        accessToken: props.accessToken,
        financialYear: fy,
        approvalStageId: 3,
      });

      const payoutListresponse = await payoutList;

      const errorCode = payoutListresponse?.response?.data?.error?.errorCode || payoutListresponse.errorCode;
      const errorMessage = payoutListresponse?.response?.data?.error?.message || payoutListresponse.message;
      if (errorCode === "403" && (payoutListresponse?.data?.error?.logoutStatus || payoutListresponse?.response?.data?.error?.logoutStatus)) {
        handleSessionExpired();
        return; // Stop further execution
      }

      setPayoutListData(payoutListresponse.data || []);
      // setPagination((prev) => ({
      //   ...prev,
      //   current: page,
      //   pageSize,
      //   total: payoutListresponse?.totalPages || 0,
      // }));
    } catch (error) {
      console.error("Error fetching payout list:", error);
    } finally {
      setDownloading(false);
    }
  };



  const fetchMissingMonthsForGenReport = async () => {
    if (isFetchingMissingMonths) return; // Prevent double clicks
    setIsFetchingMissingMonths(true);
    try {
      const missingMonths = props.payoutMissingMonthforGenReport({
        accessToken: props.accessToken,
        financialYear: financialYear,
      });
      const missingMonthsResponse = await missingMonths;
      const errorCode = missingMonthsResponse?.response?.data?.error?.errorCode || missingMonthsResponse.errorCode;
      const errorMessage = missingMonthsResponse?.response?.data?.error?.message || missingMonthsResponse.message;
      if (errorCode === "403" && (missingMonthsResponse?.data?.error?.logoutStatus || missingMonthsResponse?.response?.data?.error?.logoutStatus)) {
        handleSessionExpired();
        setIsFetchingMissingMonths(false);
        return; // Stop further execution
      }

      // Update state with the fetched data
      setMissingMonthsGen(missingMonthsResponse?.months_missing || []);

      // Filter and map the months for regeneration report
      const regenMonth = Object.entries(missingMonthsResponse?.months_done || {})
        .filter(([month, arr]) => Array.isArray(arr) && arr[0]?.version <= parseInt(regen_payout_V)) // regenerate version limit
        .map(([month]) => month);
      setMissingMonthsReGen(regenMonth || []);
    } catch (error) {
      console.error("Error fetching missing months for generation report:", error);
    } finally {
      setIsFetchingMissingMonths(false);
    }
  };


  useEffect(() => {
    const fetchAllData = async () => {
      await Promise.all([
        fetchPayoutList(pagination.current, pagination.pageSize, financialYear),
        fetchMissingMonthsForGenReport(),
      ]);

    };
    fetchAllData();
    // eslint-disable-next-line
  }, [financialYear]);


  const enabledMonthsreGen = Array.isArray(missingMonthsReGen) ?
    missingMonthsReGen.map(m => {
      const [mon] = m.split("-");
      return monthMap[mon] || mon;
    }) : [];

  // Handler for pagination change
  const handleTableChange = (pagination) => {
    fetchPayoutList(pagination.current, pagination.pageSize);
  };




  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };




  return (
    <div style={{ maxWidth: "100%" }}>

      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
          <Col md={8} className="search-bar">
            {/* <Button
              type="default"
              style={{ margin: "16px 0" , border: 'none', }}
              onClick={() => navigate(-1)}
            >
              &#8592;
            </Button> */}
          </Col>
          <Col md={4}>
            <div className="login-profie">
              <div className="img-sec">
                <h2>
                  {adminFirstName(
                    props.userDetail?.firstName ??
                    props.userDetail?.userName?.split(" ")[0]?.trim()
                  )}
                </h2>
                <h2>
                  {adminLastName(
                    props.userDetail?.lastName ??
                    props.userDetail?.userName?.split(" ")[1]?.trim()
                  )}
                </h2>
              </div>

              <div className="content-login">
                <h4>{props.userDetail?.userName}</h4>
                <h5>{props.userDetail?.roleName}</h5>

                <div className="content-login-data">
                  {/* <ChangePassword /> */}
                  <div className="admin-small-space"> </div>

                  <Logout />
                  {/* <h6>Change Password | Logout</h6> */}
                </div>
              </div>
            </div>
          </Col>
        </Col>
      </Row>

      <Row>
        <div style={{ display: "flex" }}>
          <Col lg={12} xs={12} md={12} sm={12}>
            <Col
              md={6}
              style={{ display: "flex", margin: 10 }}
              className="btn-partner"
            >
              {/* <div>
                <Select
                  style={{ width: 150 }}
                  showSearch
                  placeholder="Select financial Year"
                  optionFilterProp="label"
                  value={financialYear}
                  onChange={(value) => setFinancialYear(value)}
                  options={generateFinancialYearOptions(2022)}
                />
              </div> */}
            </Col>
          </Col>
        </div>
      </Row>

      <Row style={{ display: "flex" }}>
        <Col md={3}>
          <div>
            <Select
              style={{
                width: 150,
                marginTop: width < 750 ? 70 : 10,
              }}
              showSearch
              placeholder="Select financial Year"
              optionFilterProp="label"
              value={financialYear}
              onChange={(value) => setFinancialYear(value)}
              options={generateFinancialYearOptions(2022)}
            />
          </div>
        </Col>
        <Col
          md={9}
          style={{
            display: "flex",
            justifyItems: "end",
            alignItems: "end",
            justifyContent: "end",
          }}
          className="btn-partner"
        >

          {/* <DopdownMenuWithMonth
            lastGeneratedMonths={enabledMonthsreGen}
            name={"Regenerate Report"}
            onSelectMonth={handleGenerateReport}
            isLoadingGenerate={isLoadingReGenerate}
            setIsLoadingGenerate={setIsLoadingReGenerate}
          /> */}


        </Col>
      </Row>

      <Row>
        <Col lg={12} xs={12} md={12} sm={12}>
          <PayoutManagmentListingChanalwise
            dataSource={payoutListData}
            pagination={pagination}
            onChange={handleTableChange}
            loading={downloading}
          />
        </Col>
      </Row>


    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    payoutListByFY: (data) => dispatch(payoutListChanalwiseDataSuccess(data)),


  };

};

const mapStateToProps = (state) => {
  return {

    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
}



export default connect(mapStateToProps, mapDispatchToProps)(ChanalWiseReportCppChecker)